import { Popover } from "@/components/Popover/Popover";
import CommentIcon from "@medoma/components/icons/CommentIcon";
import { useLingui } from "@lingui/react/macro";
import { TextWithLineBreaks } from "@medoma/components/Text/Text";

export const ActivityOccurrenceCommentPopover = ({
  note,
}: {
  note: string;
}) => {
  const { t } = useLingui();

  return (
    <Popover
      trigger={{
        icon: <CommentIcon />,
        ariaLabel: t`Visa kommentar`,
      }}
    >
      <TextWithLineBreaks>{note}</TextWithLineBreaks>
    </Popover>
  );
};
